export const SESSION_STORAGE_KEYS = {
  IMPERSONATION_USER: 'impersonationUser',
  INCOMING_CALL: 'chatwoot:incoming_call',
  ACTIVE_CALL: 'chatwoot:active_call',
};
